export class ProductPolicies {
  constructor(props) {
    this.menuId = props.product;
    this.menuDescription = props.productDescription;
    this.policies = props.policies;
  }
}
